
import { Question } from '@/types/quiz';

// Sample questions data
export const questions: Question[] = [
  {
    id: 'q1',
    text: 'I prefer to spend time with large groups of people rather than alone or with a few close friends.',
    description: 'This helps us understand your social preferences and energy sources.',
    type: 'likert',
    category: 'personality'
  },
  {
    id: 'q2',
    text: 'I often worry that I am not good enough in my personal or professional life.',
    description: 'Understanding your concerns helps us provide better support.',
    type: 'likert',
    category: 'fears'
  },
  {
    id: 'q3',
    text: 'I find it easy to trust people and open up in relationships.',
    description: 'This gives insight into your relationship dynamics.',
    type: 'likert',
    category: 'relationships'
  },
  {
    id: 'q4',
    text: 'On average, how many days per week do you engage in moderate to vigorous physical activity?',
    description: 'Physical activity is a key component of overall health.',
    type: 'slider',
    category: 'health',
    min: 0,
    max: 7
  },
  {
    id: 'q5',
    text: 'I have reliable access to healthcare when I need it.',
    description: 'This helps us understand your access to healthcare resources.',
    type: 'likert',
    category: 'sdoh'
  },
  {
    id: 'q6',
    text: 'I prefer structured plans over spontaneous activities.',
    description: 'This helps us understand how you approach daily life and tasks.',
    type: 'likert',
    category: 'personality'
  },
  {
    id: 'q7',
    text: 'I often feel overwhelmed by the demands of work or daily responsibilities.',
    description: 'This helps identify potential sources of stress in your life.',
    type: 'likert',
    category: 'fears'
  },
  {
    id: 'q8',
    text: 'How many hours of quality sleep do you typically get each night?',
    description: 'Sleep is foundational to physical and mental well-being.',
    type: 'slider',
    category: 'health',
    min: 0,
    max: 10
  },
  {
    id: 'q9',
    text: 'I have a support system of people I can rely on during difficult times.',
    description: 'Social support is crucial for mental health and resilience.',
    type: 'likert',
    category: 'relationships'
  },
  {
    id: 'q10',
    text: 'I have consistent access to nutritious food options.',
    description: 'Nutrition access is a key social determinant of health.',
    type: 'likert',
    category: 'sdoh'
  },
];
